export default __webpack_public_path__ + "static/luxor-tech-748fcd1222cc40d3d667e3d36410af6b.png";